import { render, staticRenderFns } from "./nursingInstitution.vue?vue&type=template&id=5bd1bd95&scoped=true&"
import script from "./nursingInstitution.vue?vue&type=script&lang=ts&"
export * from "./nursingInstitution.vue?vue&type=script&lang=ts&"
import style0 from "./nursingInstitution.vue?vue&type=style&index=0&id=5bd1bd95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1bd95",
  null
  
)

export default component.exports